import React, { Component, Fragment, useState } from "react";
import Table from "../../../utilities/table";
import Breadcrumbs from "../../../utilities/breadcrumbs";
import { Button, Modal } from "react-bootstrap";
import FormContainer from "../../../../containers/modules/master/customer/form";
import FormContainerView from "../../../../containers/modules/master/customer/form-view";
import FormContainerLog from "../../../../containers/modules/master/customer/form-log";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSync } from "@fortawesome/free-solid-svg-icons";
import withReactContent from "sweetalert2-react-content";
import LabelActive from "../../../utilities/Status/active";
import i18n from "../../../../i18n";
const MySwal = withReactContent(Swal);

export class Customer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: {
        limit: 10,
      },
      chose:1,
      titleModal: "",
      listData: [],
      typeCust:[],
      first:0,
      breadcrumbs: [
        { link: process.env.APP_URL, title: i18n.t("Home"), class: " text-gray-600" },
        { link: null, title: i18n.t("Master"), class: " text-gray-600" },
        { link: null, title: i18n.t("Customer"), class: " text-gray-500" },
      ],
      column: [
        {
            key: "code",
            filter: { active: true, type: "Text", data: null },
            title: i18n.t("Code Customer"),
            type: "text",
            tHclass: "min-w-125px",
            tdClass: "",
            sortable:true
          },
          {
            key: "branch_name",
            filter: { active: true, type: "Text", data: null },
            title: i18n.t("Branch Name"),
            type: "text",
            tHclass: "min-w-125px",
            tdClass: "",
            // sortable:true

          },
          {
            key: "name",
            filter: { active: true, type: "Text", data: null },
            title: i18n.t("Name"),
            type: "text",
            tHclass: "min-w-125px",
            tdClass: "",
            sortable:true

          },
          {
            key: "type",
            filter:{
                active:true,
                type:'Select',
                data:[
                  { key: '', label: i18n.t("All") },
                  { key: 4, label: i18n.t("Sub Agen") },
                  { key: 5, label: i18n.t("Retailer") },
                  { key: 6, label: i18n.t("Customer") },
                  { key: 7, label: i18n.t("Wholesaler") },
                ]
            },
            title: i18n.t("Customer Type"),
            type: "text",
            tHclass: "min-w-125px",
            tdClass: "",
          },
          {
            key: "status",
            filter: {
              active: true,
              type: "Select",
              data: [
                  { key: '', label: i18n.t("All") },
                  { key: 1, label: i18n.t("Active") },
                  { key: 0, label: i18n.t("Non Active") },
              ],
            },
            title: i18n.t("Status"),
            type: "component",
            tHclass: "min-w-125px",
            tdClass: "",
            component:(data,column)=>{
                  return <LabelActive value={data[column.key]} />
            }
          },
        {
          key: "createdAt",
          filter: { active: true, type: "Text", data:null},
          title: i18n.t("Created At"),
          type: "custom",
          tHclass: "text-center min-w-125px",
          tdClass: "",
          sortable:true

        },
        {
          key: "updatedAt",
          filter: { active: false, type: "Select", data: null },
          title: i18n.t("Updated At"),
          type: "custom",
          tHclass: "text-center min-w-125px",
          tdClass: "",
          sortable:true
        
        },
        {
          key: "id",
          filter: {
            active: false,
          },
          title: i18n.t("Action"),
          type: "action",
          tHclass: "text-center min-w-150px",
          tdClass: "",
          form:'icon',
          buttons: [
            {
              key: "id",
              btnText: i18n.t("View"),
              visible: {
                key: "status",
                params: [1,2,0],
                function: (id, params) => {
                  return params.includes(id);
                },
              },
              btnFunction: (data, column) => {
                this.viewData(data);
              },
              bthClass: "btn btn-warning",
            },
            {
              key: "id",
              btnText: i18n.t("Edit"),
              visible: {
                key: "status",
                params: [],
                function: (id, params) => {
                  const {authUser}=this.props
                  if(Object.keys(authUser).length >0 && authUser.userAccess!= undefined){
                    let route=authUser.userAccess.route
                    if(route.includes('Customer Update')){
                      return true
                    }
                  }
                  return false;
                },
              },
              btnFunction: (data, column) => {
                this.updateData(data);
              },
              bthClass: "btn btn-warning",
            },
            {
              key: "id",
              btnText: i18n.t("Delete"),
              visible: {
                key: "status",
                params: [],
                function: (id, params) => {
                  const {authUser}=this.props
                  if(Object.keys(authUser).length >0 && authUser.userAccess!= undefined){
                    let route=authUser.userAccess.route
                    if(route.includes('Customer Delete')){
                      return true
                    }
                  }
                  return false;
                },
              },
              btnFunction: (data, column) => {
                this.deleteData(data);
              },
              bthClass: "btn btn-danger",
            },
            {
              key: "id",
              btnText: i18n.t("Log Update"),
              visible: {
                key: "status",
                params: [1,2,0],
                function: (id, params) => {
                  return params.includes(id);
                },
              },
              btnFunction: (data, column) => {
                this.logData(data);
              },
              bthClass: "btn btn-warning",
            },
          ],
        },
      ],
    };
    this.runSearch = this.runSearch.bind(this);
    this.updateData = this.updateData.bind(this);
    this.deleteData = this.deleteData.bind(this);
    this.createData = this.createData.bind(this);
    this.viewData = this.viewData.bind(this);
  }
  runSearch(value) {
    this.state.submit = false;
    this.props.search(value);
  }
  createData() {
    this.state.chose = '1';
    this.state.titleModal = i18n.t("Add Customer");
    this.props.createData();
  }
  updateData(id) {
    this.state.chose = '1';
    this.state.titleModal = i18n.t("Edit Customer");
    this.props.updateItem(id);
  }
  viewData(id) {
    this.state.chose = '2';
    this.state.titleModal = i18n.t("Customer");
    this.props.viewItem(id);
  }
  logData(id) {
    this.state.chose = '3';
    this.state.titleModal = i18n.t("Log Update Customer");
    this.props.logItem(id);
  }
  deleteData(id) {
    const html = (
      <>
        <div>{i18n.t('You will delete this Item')}</div>
        <Button variant="warning" onClick={() => MySwal.close()}>
          {i18n.t('Cancel')}
        </Button>
        <Button
          variant="danger"
          onClick={() => {
            this.props.deleteItem(id, this.state.search);
            MySwal.update({
              title: i18n.t("Deleting Data"),
              html: i18n.t("Please Wait ...."),
              icon: "info",
            });
            MySwal.showLoading();
          }}
        >
          {i18n.t("Delete")}
        </Button>
      </>
    );
    MySwal.fire({
      title: i18n.t("Are you sure?"),
      html: html,
      icon: "question",
      showCancelButton: false,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
    });
  }
  submitForm(status) {
    this.setState({ submit: status });
  }
  renderCreateButton(){
    const {authUser}=this.props
    if(Object.keys(authUser).length >0 && authUser.userAccess!= undefined){
      let route=authUser.userAccess.route
      if(route.includes('Customer Create')){
        return (<Button
          type="button"
          className="btn btn-primary m-1"
          onClick={(e) => this.createData()}
        >
          {i18n.t("Add Customer")}
        </Button>)
      }
    }
    return null;
  }
  render() {
    const { isProcessing, data, showModal } = this.props;
    // 
    // 
    // let type =[];
   
    this.state.listData = data;
    // if(this.state.first==0){
    //     if(customerHelperFull!= null){
    //       let dataType = [];
    //       type = customerHelperFull.type
    //       for(var i=0; i<type.length;i++){
    //         dataType.push({
    //           key:type[i].value,
    //           label:type[i].label
    //         })
    //       }
    //       this.state.first = 1;
    //     }
    // }
    return (
      <div id="customer-type">
        <Breadcrumbs url={this.state.breadcrumbs} tools={false} />
        <div
          id="kt_content_container"
          className="d-flex flex-column-fluid align-items-start container-fluid"
        >
          <div className="content flex-row-fluid" id="kt_content">
            <div className="card">
              <div className="card-header d-flex justify-content-end border-0 pt-6">
                <div className="card-toolbar">
                  <div
                    className="d-flex justify-content-end"
                    data-kt-customer-table-toolbar="base"
                  >
                    <Button
                      type="button"
                      className="btn btn-warning m-1"
                      onClick={(e) => this.runSearch(this.state.search)}
                    >
                      <FontAwesomeIcon icon={faSync}></FontAwesomeIcon>
                    </Button>
                    <Fragment>
                      {this.renderCreateButton()}
                    </Fragment>
                  </div>
                </div>
              </div>
              <div className="card-body pt-0">
                <Table
                  data={this.state.listData}
                  tools={false}
                  filterSearch={true}
                  column={this.state.column}
                  searchData={this.state.search}
                  runSearch={this.runSearch}
                  deleteData={this.deleteData}
                  updateData={this.updateData}
                  isProcessing={isProcessing}
                />
              </div>
            </div>
          </div>
        </div>
        {(this.state.chose == '1')?
        <FormContainer
          showModal={showModal}
          search={this.state.search}
          titleModal={this.state.titleModal}
        />
        :(this.state.chose == '2')?
        <FormContainerView
        showModal={showModal}
        search={this.state.search}
        titleModal={this.state.titleModal}
      />
      : 
        <FormContainerLog
        showModal={showModal}
        search={this.state.search}
        titleModal={this.state.titleModal}
      />
    }

      </div>
    );
  }
}

export default Customer;
